import { Observable } from 'rxjs';
import { 
  AuthTokens, 
  LoginRequest, 
  LogoutRequest, 
  UserModel, 
  AuthState 
} from '../models';

/**
 * Interface do repositório de autenticação
 * Define o contrato para operações de autenticação
 * Baseado no auth_repository.dart do Flutter
 */
export abstract class AuthRepository {
  // Estado de autenticação
  abstract readonly authState$: Observable<AuthState>;

  // Inicialização
  abstract initializeMsal(): Observable<boolean>;

  // Autenticação
  abstract login(request?: LoginRequest): Observable<AuthTokens>;
  abstract logout(request?: LogoutRequest): Observable<void>;
  abstract refreshToken(): Observable<AuthTokens>;

  // Estado e dados do usuário
  abstract isAuthenticated(): Observable<boolean>;
  abstract getCurrentUser(): Observable<UserModel | null>;
  abstract getAccessToken(): Observable<string | null>;

  // Gerenciamento de sessão
  abstract clearSession(): Observable<void>;
  abstract validateSession(): Observable<boolean>;
}
